const SUPPORT_QUERY_PARAM = 'support'
const REFERRER_QUERY_PARAM = 'referrer'
const FEDRAMP_CONSOLE_HOST = 'console.fedramp.sweetspotgov.com'

export interface SupportHandoffRequest {
  cleanPath: string
  message: string | null
}

const isAllowedReferrer = (url: URL) => {
  const isFedrampConsole =
    url.protocol === 'https:' &&
    (url.hostname === FEDRAMP_CONSOLE_HOST ||
      url.hostname.endsWith(`.${FEDRAMP_CONSOLE_HOST}`))
  const isLocalConsole =
    ['localhost', '127.0.0.1'].includes(url.hostname) &&
    ['http:', 'https:'].includes(url.protocol)

  return (
    (isFedrampConsole || isLocalConsole) &&
    url.username === '' &&
    url.password === '' &&
    url.search === '' &&
    url.hash === ''
  )
}

export const buildSupportHandoffPath = (currentUrl: string) => {
  const url = new URL(currentUrl)
  const params = new URLSearchParams({
    [SUPPORT_QUERY_PARAM]: 'true',
    [REFERRER_QUERY_PARAM]: `${url.origin}${url.pathname}`,
  })
  return `/?${params.toString()}`
}

export const readSupportHandoffRequest = (
  currentUrl: string,
): SupportHandoffRequest | null => {
  const url = new URL(currentUrl)
  if (url.searchParams.get(SUPPORT_QUERY_PARAM) !== 'true') return null

  const referrer = url.searchParams.get(REFERRER_QUERY_PARAM)
  let message: string | null = null
  if (referrer !== null) {
    try {
      const referrerUrl = new URL(referrer)
      if (isAllowedReferrer(referrerUrl)) {
        message = `I'm contacting support from ${referrerUrl.href}\n\n`
      }
    } catch {
      // Invalid referrers still open support without prefilled context.
    }
  }

  url.searchParams.delete(SUPPORT_QUERY_PARAM)
  url.searchParams.delete(REFERRER_QUERY_PARAM)
  const search = url.searchParams.toString()
  return {
    cleanPath: `${url.pathname}${search ? `?${search}` : ''}${url.hash}`,
    message,
  }
}
